export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "client": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Client"])},
        "team": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Équipe Estaly"])},
        "ai": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["IA"])},
        "internal_note": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Note interne"])}
      },
      "en": {
        "client": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Client"])},
        "team": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estaly Team"])},
        "ai": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI"])},
        "internal_note": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Internal note"])}
      }
    }
  })
}
